import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./css/login.css";
import { apiUrl } from "./config/api";

async function readJsonResponse(response) {
  const rawResult = await response.text();
  if (!rawResult) return {};
  try {
    return JSON.parse(rawResult);
  } catch (_err) {
    return {};
  }
}

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const normalizedEmail = email.trim();

    if (!normalizedEmail) {
      setError("Ingresa tu correo.");
      setMessage("");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    try {
      const response = await fetch(apiUrl("/auth/password-reset/request"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: normalizedEmail }),
      });
      const result = await readJsonResponse(response);

      if (!response.ok || !result.success) {
        throw new Error(result.message || "No se pudo enviar el correo de recuperación.");
      }

      setMessage("Si el correo existe, recibirás un enlace de recuperación en unos minutos.");
    } catch (err) {
      setError(err.message || "No se pudo enviar el correo de recuperación.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-page__hero" aria-labelledby="forgot-title">
        <img src="/images/logowp.png" className="login-page__logo" alt="Kakao Apps" />
        <div className="login-page__hero-copy">
          <div className="login-page__badge">Kakao Apps</div>
          <h1 id="forgot-title">Recuperar acceso</h1>
          <p>Ingresa tu correo de Kakao Apps para recibir un enlace seguro.</p>
        </div>
      </section>

      <section className="login-container" aria-label="Recuperación de contraseña">
        <form className="signin-form" onSubmit={handleSubmit} autoComplete="off">
          <div className="signin-form__fields">
            <label className="signin-field" htmlFor="reset-email">
              <span>Email</span>
              <input
                type="email"
                id="reset-email"
                required
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck="false"
                placeholder="tu@olivaymiel.cl"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </label>
          </div>

          <button className="primary-button" type="submit" disabled={loading}>
            {loading ? "Enviando..." : "Enviar enlace"}
          </button>

          <p className="signin-form__helper">
            <Link className="signin-form__link" to="/">Volver al login</Link>
          </p>
        </form>

        {message ? <div id="error-message" className="login-message login-message--success">{message}</div> : null}
        {error ? <div id="error-message" className="login-message login-message--error">{error}</div> : null}
      </section>
    </main>
  );
}

export default ForgotPassword;
